import { ModuleFE_Artifact } from './ModuleFE_Artifact.js';
export const ModulePackFE_ArtifactDB = [ModuleFE_Artifact];
//# sourceMappingURL=module-pack.js.map